<template>
    <div class="p-4 sm:ml-64">
        <div class="p-4">
            <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
                <div class="grid gap-6 mb-6 md:grid-cols-1">
                    <nav class="flex" aria-label="Breadcrumb">
                        <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                            <li class="inline-flex items-center">
                                <a href="#"
                                    class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
                                    <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor" viewBox="0 0 20 20">
                                        <path
                                            d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
                                    </svg>
                                    {{ breadCrumb.root.text }}
                                </a>
                            </li>
                            <li v-for="items in breadCrumb.child" :key="items.text">
                                <div class="flex items-center">
                                    <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" d="m1 9 4-4-4-4" />
                                    </svg>
                                    <a href="#"
                                        class="ms-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white">{{
                                            items.text
                                        }}</a>
                                </div>
                            </li>
                        </ol>
                    </nav>
                </div>
                <div class="grid gap-6 mb-6 md:grid-cols-1">
                    <div>
                        <h2 class="text-xl font-semibold text-gray-800 mb-4">Data on the Number of Users Who Accessed
                            Reflections</h2>
                        <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                            <apexchart ref="chart" type="bar" :options="chartOptions" :series="series"></apexchart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            chartOptions: {
                chart: {
                    id: "VueChart-Yearly-Reflection-Data",
                },
                xaxis: {
                    categories: [],
                },
                responsive: [{
                    breakpoint: 768,
                    options: {
                        chart: {
                            height: 300
                        }
                    }
                }]
            },
            series: [
                {
                    name: "User Access Count",
                    data: [],
                },
            ],
            breadCrumb: {
                root: { text: "Home", url: "" },
                child: [
                    { text: "Dashboard", url: "" },
                    { text: "Reflection", url: "" },
                    { text: "List", url: "" }
                ]
            },
            pageInfo: {
                totalPages: 0,
                pageNumber: 0,
                visiblePages: 5,
                pageSize: 10,
                totalElements: 0,
            },
        }
    },
    computed: {
        getReflectionStats() {
            return this.$store.getters['dashboard/getReflectionStats']
        },
    },
    methods: {
        async loadReflectionStats() {
            await this.$store.dispatch('dashboard/fetchReflectionStats')
            const stats = this.getReflectionStats
            this.chartOptions.xaxis.categories = stats.map(item => item.tahun)
            this.series[0].data = stats.map(item => item.jumlahAkses)

            this.$refs.chart.updateOptions({
                xaxis: {
                    categories: this.chartOptions.xaxis.categories
                }
            })
        }
    },
    mounted() {
        this.loadReflectionStats()
    }
}
</script>